import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CryptoJS from "crypto-js";
import env from "../../config.json";
import axios from "axios";
import TripServices from "../../services/externalServices/trip/TripServices";

const PHONE_PE_CONFIG = env.PHONE_PE_CONFIG;

const PaymentProcessing = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get transaction ID from URL parameters
  const queryParams = new URLSearchParams(location.search);
  let merchantTransactionId = queryParams.get("merchantTransactionId");
  const tripId=queryParams.get("tripId")
  // Fallback: Retrieve from session storage if not in URL
  if (!merchantTransactionId) {
    merchantTransactionId = sessionStorage.getItem("merchantTransactionId");
  }

  console.log("Merchant Transaction ID:", merchantTransactionId);

  // function successCallback(responseData) {
  //   // setShowFeedback(true); //Raj Commented and it should navigate based on the module

  //   // successCallback(response);
  //   console.log("UPI payment successful", responseData);
  //   console.error("response data", responseData);

  //   // updateTripPaymentStatus('online', true, responseData);

  //   //
  //   (async () => {
  //     try {
  //       console.info("Updating invoice in the background...",tripId);
  //       await TripServices.updateInvoice(tripId);
  //       navigate("/booking-status", {
  //           state: {
  //             tripId: tripId,
  //             status: responseData.responseCode,
  //           },
  //         });
  //       console.info("Invoice update successful.");
  //     } catch (error) {
  //       console.error("Failed to update invoice:", error);
  //       // Optionally log this for further troubleshooting
  //     }
  //   })();

  //   // setShowRetry(false);
  //   // setShowFeedback(true)

  //   // {
  //   //   paymentUpdatedToDB && (
  //   //     callingModule === 'TourPackage' ? (
  //   //       // If the module is 'TourPackage'
  //   //       navigate(navigationConstants.tourPackageStatus, {
  //   //         title: 'Booking Status',
  //   //         tripId: tripid,
  //   //       })
  //   //     ) : (
  //   //       // If it's another module
  //   //       setShowFeedback(true)
  //   //     )
  //   //   )
  //   // }
  // }

  async function successCallback(responseData) {
    console.log("UPI payment successful", responseData);
    console.info("Updating invoice in the background...", tripId);
  
    try {
      // Wait for the invoice update before navigating
      const res=await TripServices.updateInvoice(tripId);
      console.info("Invoice update successful.");
  
      if(res.success){
        navigate("/booking-status", {
          state: {
            tripId: tripId,
            status: responseData.responseCode,
          },
        });
      }
      // Navigate only after the invoice update completes
     
  
    } catch (error) {
      console.error("Failed to update invoice:", error);
      // alert("Failed to update the invoice. Please try again.");
    }
  }

  async function failureCallback(responseData) {
    console.log("UPI payment successful", responseData);
    // console.info("Updating invoice in the background...", tripId);
  
    try {
      // Wait for the invoice update before navigating
      // const res=await TripServices.updateInvoice(tripId);
      // console.info("Invoice update successful.");
  
      // if(res.success){
        navigate("/booking-status", {
          state: {
            tripId: tripId,
            status: responseData.responseCode,
          },
        });
      // }
      // Navigate only after the invoice update completes
     
  
    } catch (error) {
      console.error("Failed to update invoice:", error);
      alert("Failed to update the invoice. Please try again.");
    }
  }
  

  const checkPaymentStatus = async (transactionId) => {
    try {
      const getPaymentStatus = async (merchantTransactionId) => {
        return await axios.get(
          // `https://payment.cruze.asia/payments/test/${merchantTransactionId}`
          // `https://ticket.wmdservices.asia/api/theatres/payments/test/${merchantTransactionId}`
          `${PHONE_PE_CONFIG.statusCheckUrl}${merchantTransactionId}`
        );
      };
      const res = await getPaymentStatus(transactionId);
      console.log("res", res);
      // const url = `https://api-preprod.phonepe.com/apis/pg-sandbox/pg/v1/status/${transactionId}`;
      // const stringToHash = `/pg/v1/status/${transactionId}` + PHONE_PE_CONFIG.salt_key;
      // const checksum = CryptoJS.SHA256(stringToHash).toString() + "###" + PHONE_PE_CONFIG.salt_Index;

      // const response1 = await fetch(url, {
      //     method: "GET",
      //     headers: {
      //         "Content-Type": "application/json",
      //         "X-VERIFY": checksum
      //     }
      // });
      console.log("Payment Status Response:", res);
      const data = res.data;

     const paymentData = res.data.data;
      if (data.success && data.data.state === "COMPLETED") {
        // alert("Payment successful!");
        successCallback(paymentData);
      } else {
        // alert("Payment failed or is pending. Please check again.");
        failureCallback(paymentData)
        // navigate("/failure");
      }
    } catch (err) {
      console.error("Error checking payment status:", err);
      alert("Error checking payment status.");
      // failureCallback(paymentData)
    }
  };

  useEffect(() => {
    if (merchantTransactionId) {
      checkPaymentStatus(merchantTransactionId);
    } else {
      alert("Transaction ID missing!");
      navigate("/");
    }
  }, [merchantTransactionId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h2 className="text-lg font-semibold">Processing Payment...</h2>
        <p>Please wait while we verify your payment status.</p>
      </div>
    </div>
  );
};

export default PaymentProcessing;
